import { Alert, Box, CircularProgress, Dialog } from "@mui/material"
import type { FC } from "react"

import { useGetGlTransaction } from "../../hooks/useGetGlTransaction"
import { type GlTransactionDialogMode } from "../../types/dialog"

import { EditGlTransactionDialogForm } from "./EditGlTransactionDialogForm"

interface EditGlTransactionDialogProps {
  glTransactionId: string
  mode?: GlTransactionDialogMode
  onClose: () => void
  onSuccess?: () => void
}

export const EditGlTransactionDialog: FC<EditGlTransactionDialogProps> = ({
  glTransactionId,
  mode = "edit",
  onClose,
  onSuccess,
}) => {
  const { glTransaction, isFetching, error } = useGetGlTransaction(glTransactionId)

  if (isFetching) {
    return (
      <Dialog open maxWidth='md' fullWidth>
        <Box className='flex items-center justify-center p-16'>
          <CircularProgress />
        </Box>
      </Dialog>
    )
  }

  if (error || !glTransaction) {
    return (
      <Dialog open onClose={onClose} maxWidth='md' fullWidth>
        <Box className='flex items-center justify-center p-16'>
          <Alert severity='error'>Failed to load transaction. Please try again.</Alert>
        </Box>
      </Dialog>
    )
  }

  return (
    <EditGlTransactionDialogForm glTransaction={glTransaction} mode={mode} onClose={onClose} onSuccess={onSuccess} />
  )
}
